import { takeEvery } from 'redux-saga/effects';

import * as phoneActionTypes from 'store/modules/phone/actionTypes';

import { sendVerificationCode } from './utils';

export default function* listenSendVerificationCode() {
  yield takeEvery(phoneActionTypes.SEND_VERIFICATION_CODE, sendVerificationCode);
}
